import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import {
  checkBackgroundIsDark,
  getPaneIndex,
  getWindowLocationPath,
  isScontentLinkExpire,
  kFormatter,
} from "../../../../../redux/constants";

import { getNetworkAuthorPostDetails } from "../../../../../redux/actions/Network";
import "./AuthorDetailsWithPosts.scss";
import ProfilePic from "../../../../../assets/Profile_Pic.svg";
import verified from "../../../../../assets/verified.svg";
import trendsIcon from "../../../../../assets/Trend.svg";
import ClockIcon from "../../../../../assets/Clock.svg";
import defaultImg from "../../../../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../../../../assets/brandLogos/Default_Brand.svg";
import placeHolderImg from "../../../../../assets/placeholder_img.png";
import { Image, Tooltip } from "antd";
import ErrorBoundary from "../../../../../ErrorBoundary";
import NoGraphData from "../../../../workspace/DisplayChart/NoGraphData";
import VideoPreview from "../../../../WidgetMaker/VideoPreview";
import Carousel from "../../../../WidgetMaker/Carousel";
import SinglePostCard from "./PostCard/SinglePostCard";
import SortBy from "../../../../WidgetMaker/SortBy";
import PaginationComponent from "../../../../WidgetMaker/PaginationComponent";
import { getCSSVariableValue } from "../../../../../redux/constants/networkEnums";
const AuthorDetailsWithPosts = ({
  networkDeepDiveObj,
  setNetworkDeepDiveObj,
  isNetworkModalOpen,
  isVisNetworkGraph,
  section_index,
  widget_index,
  metadata,
  style,
  PdfDownloadStatus,
  id,
  type,
  dashboard,
}) => {
  const dispatch = useDispatch();
  const userInfoContainerRef = useRef(null);
  const [refInfoContainerUpdated, setRefInfoContainerUpdated] = useState(false);

  // callback function got called when reference of tooltip is loaded
  const measuredUserInfoRef = useCallback((node) => {
    if (node !== null) {
      userInfoContainerRef.current = node;
      setRefInfoContainerUpdated(!refInfoContainerUpdated);
    }
  }, []);

  const userTweetsContainerRef = useRef(null);
  const [refUserTweetsUpdated, setRefUserTweetsUpdated] = useState(false);

  // callback function got called when reference of tooltip is loaded
  const measuredUserTweetsRef = useCallback((node) => {
    if (node !== null) {
      userTweetsContainerRef.current = node;
      setRefUserTweetsUpdated(!refUserTweetsUpdated);
    }
  }, []);

  const sortByDivRef = useRef(null);
  const [refSortByUpdated, setRefSortByUpdated] = useState(false);

  // callback function got called when reference of tooltip is loaded
  const measuredSortByRef = useCallback((node) => {
    if (node !== null) {
      sortByDivRef.current = node;
      setRefSortByUpdated(!refSortByUpdated);
    }
  }, []);

  const paginationDivRef = useRef(null);
  const [refPaginationUpdated, setRefPaginationUpdated] = useState(false);

  // callback function got called when reference of tooltip is loaded
  const measuredPaginationRef = useCallback((node) => {
    if (node !== null) {
      paginationDivRef.current = node;
      setRefPaginationUpdated(!refPaginationUpdated);
    }
  }, []);

  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const network = useSelector((state) => state?.Network);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const screenRefreshEvent = useSelector(
    (state) => state?.Screens?.refreshEvent
  );
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state?.ApiCall?.brandlogicalgroup?.data?.result
  );
  const [authorPostDetailsMetaData, setAuthorPostDetailsMetaData] =
    useState(null);
  const [authorPostDetailsApiCallStatus, setAuthorPostDetailsApiCallStatus] =
    useState(false);
  const [isBioVisible, setIsBioVisible] = useState(true);

  const [isImage, setIsImage] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  // const onImageError = (e) => {
  //   if (e?.type === "error") {
  //     setIsImage(true);
  //   } else {
  //     setIsImage(false);
  //   }
  //   return (e.target.src = defaultImg);
  // };
  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };

  useEffect(() => {
    // console.log("\n\n\nuseEffect got called : on initial only ");
    try {
      if (networkDeepDiveObj && !authorPostDetailsMetaData) {
        let pathName = getWindowLocationPath()?.toLowerCase();

        if (
          panes?.[getPaneIndex(panes, activeKey)]?.isDashboard ||
          (shareBrands && shareableLinkDeepDiveStatus) ||
          pathName === "CommandCenter"?.toLowerCase()
        ) {
          let index =
            !shareBrands &&
            pathName !== "CommandCenter"?.toLowerCase() &&
            getPaneIndex(panes, activeKey);
          let shareSections = shareTemplateData?.section
            ? shareTemplateData?.section?.[0]
            : shareTemplateData?.sections?.[section_index];
          let widget_metadata =
            pathName === "CommandCenter"?.toLowerCase()
              ? section_index !== null &&
                section_index !== undefined &&
                screen?.sections &&
                screen?.sections?.[section_index]?.widgets?.[widget_index]
                ? screen?.sections?.[section_index]?.widgets?.[widget_index]
                : screen?.section?.[0]?.widgets?.[widget_index]
                ? screen?.section?.[0]?.widgets?.[widget_index]
                : screen?.widgets
                ? screen?.widgets?.[widget_index]
                : null
              : shareBrands
              ? shareSections?.widgets?.[widget_index]
              : section_index >= 0 && panes?.[index]?.sections
              ? panes?.[index]?.sections?.[section_index]?.widgets?.[
                  widget_index
                ]
              : panes?.[index]?.section?.[0]?.widgets?.[widget_index];
          let updatedWidgetMetaData = structuredClone(widget_metadata);
          let updatedPaylaod = structuredClone(updatedWidgetMetaData?.payload);
          let updatedFiltersForMetaData =
            updatedWidgetMetaData?.filters &&
            Array.isArray(updatedWidgetMetaData?.filters)
              ? [...updatedWidgetMetaData?.filters]
              : [];
          let updatedFiltersForPayload =
            updatedPaylaod?.filters && Array.isArray(updatedPaylaod?.filters)
              ? [...updatedPaylaod?.filters]
              : [];

          //   updatedFiltersForPayload?.push({
          //     attribute: "tweettype",
          //     type: "varchar",
          //     columns: [
          //       {
          //         name: "Retweet",
          //         type: networkDeepDiveObj?.isretweetauthor
          //           ? "include"
          //           : "exclude",
          //         display_name: null,
          //       },
          //     ],
          //     data_source: "mentions",
          //   });

          updatedFiltersForPayload?.push({
            attribute: "authorid",
            type: "varchar",
            columns: [
              {
                name: networkDeepDiveObj?.u_authorid
                  ? networkDeepDiveObj?.u_authorid
                  : networkDeepDiveObj?.AuthorName,
                type: "include",
                display_name: networkDeepDiveObj?.AuthorName
                  ? networkDeepDiveObj?.AuthorName
                  : networkDeepDiveObj?.main_author
                  ? networkDeepDiveObj?.main_author
                  : networkDeepDiveObj?.AuthorName,
              },
            ],
            data_source: "mentions",
          });
          // updatedFiltersForMetaData?.push({
          //   attribute: "tweettype",
          //   type: "varchar",
          //   columns: [
          //     {
          //       name: "Retweet",
          //       type: networkDeepDiveObj?.isretweetauthor
          //         ? "include"
          //         : "exclude",
          //       display_name: null,
          //     },
          //   ],
          //   data_source: "mentions",
          // });
          // New Filter Added for removing user shares
          if (networkDeepDiveObj?.isretweetauthor === 0) {
            updatedFiltersForPayload?.push({
              attribute: "posttype",
              type: "varchar",
              columns: [
                {
                  name: "User Share",
                  type: "exclude",
                  display_name: "User Share",
                },
              ],
              data_source: "mentions",
            });
            updatedFiltersForMetaData?.push({
              attribute: "posttype",
              type: "varchar",
              columns: [
                {
                  name: "User Share",
                  type: "exclude",
                  display_name: "User Share",
                },
              ],
              data_source: "mentions",
            });
          }

          updatedPaylaod.chart.chart_type = "post-card";
          updatedPaylaod.filters = updatedFiltersForPayload;
          updatedPaylaod.order_by = {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
          updatedWidgetMetaData.chart.chart_type = "post-card";
          updatedWidgetMetaData.graph_type = "post-card";
          updatedWidgetMetaData.order_by = {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
          updatedWidgetMetaData.filters = updatedFiltersForMetaData;
          updatedWidgetMetaData.payload = updatedPaylaod;
          delete updatedWidgetMetaData?.graphData;
          delete updatedWidgetMetaData?.persist_graphdata;
          setAuthorPostDetailsMetaData(updatedWidgetMetaData);
        }
      }
    } catch (error) {
      console.error("Error on NetworkDeepdive : Api Call :  ", error);
    }
  }, [networkDeepDiveObj]);
  // after authorPostDetailsMetaData set call api for get post details
  useEffect(() => {
    try {
      // console.log(
      //   "authorPostDetailsMetaData : ",
      //   authorPostDetailsMetaData,
      //   "networkDeepDiveObj : ",
      //   networkDeepDiveObj
      // );
      if (authorPostDetailsMetaData && !authorPostDetailsApiCallStatus) {
        setAuthorPostDetailsApiCallStatus(true);
        if (authorPostDetailsMetaData?.payload) {
          let updatedPayloadWithPostCard;
          const payloadObj = {
            body: authorPostDetailsMetaData?.payload,
            u_authorid: networkDeepDiveObj?.u_authorid,
            widget_id: networkDeepDiveObj?.isretweetauthor ? "NG-3" : "NG-2",
            payload: true,
            data_source: "mentions",
            isCommandCenter: authParams?.screen_id ? true : false,
          };
          // console.log("payloadObj in authorDetailsWithPosts : ", payloadObj);
          authParams && dispatch(getNetworkAuthorPostDetails(payloadObj));
        }
      }
    } catch (error) {
      console.error(
        "Error on Network Author Details With Posts : Api Call :  ",
        error
      );
    }
  }, [authorPostDetailsMetaData]);
  // useEffect(() => {
  //   console.log("\n\n\n useEffect got called : on initial network ");
  //   console.log("network deepdive : ", network);
  // }, [network]);

  const postCardGraphData = useMemo(() => {
    if (network?.authorPostDetailsData) {
      return typeof network?.authorPostDetailsData === "string"
        ? network?.authorPostDetailsData
        : network?.authorPostDetailsData?.data?.["post-card"];
    } else {
      return null;
    }
  }, [network?.authorPostDetailsData]);

  const postData = useMemo(() => {
    return Array.isArray(postCardGraphData)
      ? postCardGraphData?.[0]?.data && postCardGraphData?.[0]?.data?.length > 0
        ? postCardGraphData?.[0]?.data
        : []
      : postCardGraphData?.data && postCardGraphData?.data?.length > 0
      ? postCardGraphData?.data
      : [];
  }, [postCardGraphData]);
  const onImageError = (e) => {
    return (e.target.src = ProfilePic);
  };
  const toggleBioVisibility = () => {
    setIsBioVisible(!isBioVisible);
  };

  const handleSortByOptionChange = (updatedMetaData) => {
    // console.log("handleSortByOptionChange got called : ", updatedMetaData);
    let updatedAuthorPostDetailsMetaData = structuredClone(
      authorPostDetailsMetaData
    );
    let updatedPaylaod = structuredClone(
      updatedAuthorPostDetailsMetaData?.payload
    );
    if (
      !isEqual(
        updatedAuthorPostDetailsMetaData?.order_by,
        updatedMetaData?.order_by
      )
    ) {
      updatedPaylaod.order_by = updatedMetaData?.order_by
        ? updatedMetaData?.order_by
        : {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
      updatedAuthorPostDetailsMetaData.order_by = updatedMetaData?.order_by
        ? updatedMetaData?.order_by
        : {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
      updatedAuthorPostDetailsMetaData.payload = updatedPaylaod;
      delete updatedAuthorPostDetailsMetaData?.graphData;
      delete updatedAuthorPostDetailsMetaData?.persist_graphdata;
      // console.log(
      //   "updatedAuthorPostDetailsMetaData : ",
      //   updatedAuthorPostDetailsMetaData
      // );
      setAuthorPostDetailsApiCallStatus(false);
      setAuthorPostDetailsMetaData(updatedAuthorPostDetailsMetaData);
    }
  };
  const handlePaginationChange = (updatedMetaData) => {
    let updatedAuthorPostDetailsMetaData = structuredClone(
      authorPostDetailsMetaData
    );
    let updatedPaylaod = structuredClone(
      updatedAuthorPostDetailsMetaData?.payload
    );
    if (
      !isEqual(
        updatedAuthorPostDetailsMetaData?.order_by,
        updatedMetaData?.order_by
      )
    ) {
      updatedPaylaod.order_by = updatedMetaData?.order_by
        ? updatedMetaData?.order_by
        : {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
      updatedAuthorPostDetailsMetaData.order_by = updatedMetaData?.order_by
        ? updatedMetaData?.order_by
        : {
            data_source: "mentions",
            attribute: "engagement",
            offset: 0,
            sort_order: "desc",
          };
      updatedAuthorPostDetailsMetaData.payload = updatedPaylaod;
      delete updatedAuthorPostDetailsMetaData?.graphData;
      delete updatedAuthorPostDetailsMetaData?.persist_graphdata;
      // console.log(
      //   "updatedAuthorPostDetailsMetaData : ",
      //   updatedAuthorPostDetailsMetaData
      // );
      setAuthorPostDetailsApiCallStatus(false);
      setAuthorPostDetailsMetaData(updatedAuthorPostDetailsMetaData);
    }
  };
  useEffect(() => {
    setRefInfoContainerUpdated(!refInfoContainerUpdated);
    setRefUserTweetsUpdated(!refUserTweetsUpdated);
    setRefSortByUpdated(!refSortByUpdated);
    setRefPaginationUpdated(!refPaginationUpdated);
  }, [
    userInfoContainerRef?.current?.clientHeight,
    userTweetsContainerRef?.current?.clientHeight,
    sortByDivRef?.current?.clientHeight,
    paginationDivRef?.current?.clientHeight,
  ]);

  const primaryBgColor = getCSSVariableValue("--locobuzz-primary-bg-color");
  const isDarkBackground = useMemo(() => {
    return checkBackgroundIsDark(primaryBgColor);
  }, [primaryBgColor]);
  // console.log(
  //   "postCardGraphData : ",
  //   postCardGraphData,
  //   "postData : ",
  //   postData
  // );
  return (
    <>
      <div className="NetwokAuthorDetails">
        <div className="Screen__userInfo" ref={measuredUserInfoRef}>
          <div className="Screen__userInfo--user">
            <img
              className="Screen__userInfo--user-img"
              src={
                networkDeepDiveObj?.ProfilePicture
                  ? networkDeepDiveObj?.ProfilePicture
                  : ProfilePic
              }
              onError={(el) => onImageError(el)}
              title={networkDeepDiveObj?.AuthorName}
              style={{
                width: "4rem",
                height: "4rem",
                borderRadius: "50%",
              }}
            />
            <div className="Screen__userName">
              <div
                className="d-flex align-items-center"
                style={{ width: "90%" }}
              >
                <div
                  className={`Screen__userName--text
                        ${
                          networkDeepDiveObj?.UserSentiment === 0
                            ? "text-neutral"
                            : networkDeepDiveObj?.UserSentiment === 1
                            ? "text-positive"
                            : networkDeepDiveObj?.UserSentiment === 2
                            ? "text-negetive"
                            : ""
                        }
                        `}
                >
                  {networkDeepDiveObj?.AuthorURL &&
                  networkDeepDiveObj?.AuthorURL !== "NA" ? (
                    <a
                      className={
                        networkDeepDiveObj?.AuthorURL &&
                        networkDeepDiveObj?.AuthorURL !== "NA"
                          ? ""
                          : "pointer-events1 cursor-default"
                      }
                      href={
                        networkDeepDiveObj?.AuthorURL &&
                        networkDeepDiveObj?.AuthorURL !== "NA"
                          ? networkDeepDiveObj?.AuthorURL
                          : ""
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {networkDeepDiveObj?.AuthorName}
                    </a>
                  ) : (
                    <>{networkDeepDiveObj?.AuthorName}</>
                  )}
                </div>
                {networkDeepDiveObj?.AuthorIsVerified !== "NA" &&
                networkDeepDiveObj?.AuthorIsVerified &&
                networkDeepDiveObj?.AuthorIsVerified > 0 ? (
                  <img
                    src={verified}
                    alt="verified"
                    className="authorImg ml-1"
                    style={{ width: "1.5rem" }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div className="Screen__userName--id">
                {networkDeepDiveObj?.AuthorURL &&
                networkDeepDiveObj?.AuthorURL !== "NA" ? (
                  <a
                    className={
                      networkDeepDiveObj?.AuthorURL &&
                      networkDeepDiveObj?.AuthorURL !== "NA"
                        ? ""
                        : "pointer-events1 cursor-default"
                    }
                    href={
                      networkDeepDiveObj?.AuthorURL &&
                      networkDeepDiveObj?.AuthorURL !== "NA"
                        ? networkDeepDiveObj?.AuthorURL
                        : ""
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    {networkDeepDiveObj?.AuthorScreenName}
                  </a>
                ) : (
                  <>{networkDeepDiveObj?.AuthorScreenName}</>
                )}
              </div>
            </div>
            {/* <div
                    className="Screen__userInfo--user-pieChart"
                    onClick={(e) => handleTrands(e)}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 1.99955C10.4679 1.99678 8.95565 2.34609 7.57996 3.02052C6.20428 3.69495 5.00196 4.67647 4.0658 5.88931C3.12964 7.10216 2.48469 8.51389 2.18072 10.0155C1.87675 11.5172 1.92189 13.0686 2.31266 14.5501C2.70344 16.0315 3.42938 17.4034 4.43448 18.5597C5.43957 19.7161 6.69693 20.626 8.10951 21.2193C9.52208 21.8126 11.0521 22.0734 12.5815 21.9815C14.1108 21.8897 15.5986 21.4477 16.93 20.6896H17H17.05C18.9753 19.5936 20.4821 17.8893 21.334 15.8443C22.1858 13.7993 22.3345 11.5292 21.7566 9.39058C21.1788 7.25192 19.9071 5.36569 18.1412 4.02797C16.3754 2.69025 14.2153 1.97678 12 1.99955ZM13 4.06955C14.76 4.29275 16.3959 5.09465 17.6504 6.34914C18.9049 7.60363 19.7068 9.23953 19.93 10.9996H13V4.06955ZM12 19.9996C9.97453 19.9857 8.02968 19.2041 6.55796 17.8124C5.08624 16.4207 4.19723 14.5225 4.07033 12.5009C3.94342 10.4794 4.58808 8.48495 5.87421 6.92011C7.16033 5.35528 8.99216 4.33657 11 4.06955V11.9996C11.004 12.1193 11.0276 12.2375 11.07 12.3496V12.4296V12.4996L15.07 19.3696C14.0998 19.7848 13.0554 19.9991 12 19.9996ZM16.83 18.3596L13.73 12.9996H19.93C19.7954 14.0541 19.4519 15.0713 18.9196 15.9916C18.3874 16.9119 17.677 17.7169 16.83 18.3596Z"
                        fill={sentimentColor}
                      />
                    </svg>
                  </div> */}
          </div>
          <div className="Screen__userInfo--bio">
            <div
              className={`Screen__bioTitle ${isBioVisible ? "topArrow" : ""}`}
              onClick={toggleBioVisibility}
            >
              Bio
            </div>
            {isBioVisible && (
              <div className="Screen__bioContent">
                {networkDeepDiveObj?.AuthorBio ? (
                  <>{networkDeepDiveObj?.AuthorBio}</>
                ) : (
                  <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center pt-15 pb-15 w-100">
                    Bio not found
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className={`Screen__userInfo--following d-flex align-items-center ${
              networkDeepDiveObj?.UserSentiment === 0
                ? "background-neutral"
                : networkDeepDiveObj?.UserSentiment === 1
                ? "background-positive"
                : networkDeepDiveObj?.UserSentiment === 2
                ? "background-negetive"
                : ""
            }`}
          >
            <div className="Screen__userInfo--following-flex">
              <div className="following-heading">Followers</div>
              <Tooltip title={networkDeepDiveObj?.Followers?.toLocaleString()}>
                <div className="following-count">
                  {kFormatter(networkDeepDiveObj?.Followers)}
                </div>
              </Tooltip>
            </div>
            <div className="Screen__userInfo--following-flex">
              <div className="following-heading">Following</div>
              <Tooltip title={networkDeepDiveObj?.Following?.toLocaleString()}>
                <div className="following-count">
                  {kFormatter(networkDeepDiveObj?.Following)}
                </div>
              </Tooltip>
            </div>
            <div className="Screen__userInfo--following-flex">
              <div className="following-heading">Location</div>
              <Tooltip
                title={
                  networkDeepDiveObj?.last_tweets?.[0]?.location
                    ? networkDeepDiveObj?.last_tweets?.[0]?.location
                    : ""
                }
              >
                <div className="following-count">
                  {networkDeepDiveObj?.last_tweets?.[0]?.location
                    ? networkDeepDiveObj?.last_tweets?.[0]?.location
                    : "NA"}
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
        <div
          className="Screen__postCards"
          ref={measuredUserTweetsRef}
          style={{
            height:
              "calc(100% - " +
              (userInfoContainerRef?.current?.clientHeight > 0
                ? userInfoContainerRef?.current?.clientHeight
                : 0) +
              "px)",
          }}
        >
          {network?.authorPostDetailsLoader ? (
            <div className="loader h-100">
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : typeof network?.authorPostDetailsData !== "string" &&
            postCardGraphData ? (
            <>
              <div className="Screen__postCards--tweetWrap">
                <div className="Screen__tweetTitle" ref={measuredSortByRef}>
                  <div>Author Posts</div>
                  <div className="d-flex align-items-center">
                    {/* Sort by{" "} */}
                    <SortBy
                      filterPills={postCardGraphData?.[0]?.["filter-pills"]}
                      metadata={authorPostDetailsMetaData}
                      // section_index={section_index}
                      // widget_index={widget_index}
                      // isPreviewState={isPreviewState}
                      // PdfDownloadStatus={PdfDownloadStatus}
                      // PptGeneratingStatus={PptGeneratingStatus}
                      // widget_id={widget_id}
                      chart_type={"post-card"}
                      dashboard={dashboard}
                      deepDive={false}
                      type={"authorDetailsWithPost"}
                      onSortByOptionChange={handleSortByOptionChange}
                    />
                  </div>
                </div>

                <div
                  className="Screen__tweet"
                  style={{
                    height:
                      "calc(100% - " +
                      ((sortByDivRef?.current?.clientHeight > 0
                        ? sortByDivRef?.current?.clientHeight
                        : 0) +
                        (paginationDivRef?.current?.clientHeight > 0
                          ? paginationDivRef?.current?.clientHeight
                          : 0)) +
                      "px)",
                  }}
                >
                  {postData?.length > 0 ? (
                    postData?.map((tweetData, index) => {
                      return (
                        <div
                          className="Screen__tweet--tweets"
                          key={index}
                          // onMouseOver={(e) =>
                          //   stopSetTimeout(
                          //     e,
                          //     selectedAuthorCardProfile?.AuthorSocialID
                          //   )
                          // }
                          // onMouseOut={(e) =>
                          //   startSetTimeout(
                          //     e,
                          //     selectedAuthorCardProfile?.AuthorSocialID
                          //   )
                          // }
                        >
                          <div
                            className={`Screen__tweetsBorder ${
                              tweetData?.SentimentType === "Neutral"
                                ? " border-neutral"
                                : tweetData?.SentimentType === "Positive"
                                ? "border-positive"
                                : tweetData?.SentimentType === "Negative"
                                ? "border-negetive"
                                : ""
                            }`}
                          ></div>
                          <div
                            className={`Screen__tweetsContent ${
                              tweetData?.SentimentType === "Neutral"
                                ? "neutral-topBorder"
                                : tweetData?.SentimentType === "Positive"
                                ? "positive-topBorder"
                                : tweetData?.SentimentType === "Negative"
                                ? "negetive-topBorder"
                                : ""
                            }`}
                          >
                            <div className="Screen__tweetsContent--message">
                              <ErrorBoundary>
                                <SinglePostCard
                                  cardKey={`Screen__tweets_${index}`}
                                  postData={tweetData}
                                  // backgroundColor={
                                  //   authParams?.theme_type === "1" ||
                                  //   authParams?.screen_id
                                  //     ? "#243B65"
                                  //     : "ffffff"
                                  // }
                                  // color={
                                  //   authParams?.theme_type === "1" ||
                                  //   authParams?.screen_id
                                  //     ? "#fffff"
                                  //     : "#3b5175"
                                  // }
                                  backgroundColor={primaryBgColor}
                                  color={"var(--locobuzz-primary-text-color)"}
                                  arrowDirection={"left"}
                                  isDarkBackground={isDarkBackground}
                                  isTweetView={true}
                                  hideHeaderOfCard={
                                    !networkDeepDiveObj?.isretweetauthor
                                  }
                                />
                              </ErrorBoundary>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="Screen__tweet--noTweetsMessage">
                      No tweets are available.
                    </div>
                  )}
                </div>
                <div
                  className="Screen__tweetPagination"
                  ref={measuredPaginationRef}
                >
                  <PaginationComponent
                    data={postData}
                    filterPills={postCardGraphData?.[0]?.["filter-pills"]}
                    totalPageNo={postCardGraphData?.[0]?.["no_of_pages"]}
                    metadata={authorPostDetailsMetaData}
                    // section_index={section_index}
                    // widget_index={widget_index}
                    // mentionPage={mentionPage}
                    pagination={true}
                    // deepDive={deepDive}
                    // isPreviewState={isPreviewState}
                    // dashboard={dashboard}
                    // PdfDownloadStatus={PdfDownloadStatus}
                    // PptGeneratingStatus={PptGeneratingStatus}
                    // widget_id={widget_id}
                    chart_type={"post-card"}
                    type={"authorDetailsWithPost"}
                    onPaginationChange={handlePaginationChange}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="portlet_images d-flex text-center h-100">
              <div className="m-auto">
                <ErrorBoundary>
                  <NoGraphData
                    errorCode="No Data Found"
                    isCommandCenterScreen={true}
                  />
                </ErrorBoundary>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default React.memo(AuthorDetailsWithPosts, isEqual);
